import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import { formatCentsToDollars } from 'marketplace-ui-common/utils/currency';
import { RatingAxes } from 'marketplace-ui-reviews/constants/RatingAxes';
import { useReviews } from 'marketplace-ui-reviews/hooks/useReviews';
import JsonLd from 'marketplace-ui-common/components/elements/JsonLd';
// @ts-expect-error untyped dependency
import { getReviewFilters } from '../../../selectors/reviews';
import { getAppContextCoreType } from '../../../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
function AssetDetailsStructuredData({
  canonicalUrl,
  cents,
  metaDescription,
  name,
  offeringType,
  offeringId,
  overallRating,
  providerName,
  reviewCount,
  thumbnailUrl,
  versionPublishedAt
}) {
  const appContext = useSelector(getAppContextCoreType);
  const reviewFilters = useSelector(getReviewFilters);
  const {
    reviews: reviewsList
  } = useReviews({
    appContext,
    reviewFilters,
    offeringId,
    reviewType: offeringType
  });
  const firstReview = reviewsList[0];
  const item = useMemo(() => {
    const priceValidUntil = I18n.moment(versionPublishedAt).add(10, 'y');
    const data = {
      '@context': 'http://schema.org',
      '@type': 'Product',
      category: 'HubSpot CMS',
      // TODO: Verify for modules details page
      url: canonicalUrl,
      description: metaDescription,
      name: `${name} ${offeringType === 'THEME' ? 'Theme' : 'Module'}`,
      image: thumbnailUrl,
      brand: {
        '@type': 'Brand',
        name: providerName
      },
      offers: {
        '@type': 'Offer',
        price: `${formatCentsToDollars(cents)}`,
        priceCurrency: 'USD',
        priceValidUntil,
        itemCondition: 'http://schema.org/NewCondition',
        availability: 'http://schema.org/InStock',
        url: canonicalUrl
      }
    };
    if (firstReview) {
      data.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: `${overallRating}`,
        reviewCount: `${reviewCount}`
      };
      data.review = [{
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: `${firstReview.get('ratings').get(RatingAxes.OVERALL)}`,
          bestRating: '5'
        },
        author: {
          '@type': 'Person',
          name: firstReview.get('reviewerDisplayName')
        }
      }];
    }
    return data;
  }, [canonicalUrl, cents, firstReview, metaDescription, offeringType, overallRating, name, providerName, reviewCount, thumbnailUrl, versionPublishedAt]);
  return /*#__PURE__*/_jsx(JsonLd, {
    item: item
  });
}
export default AssetDetailsStructuredData;